import { gql } from '@apollo/client';

const PRICE_DETAILS_FRAGMENT = gql`
  fragment PriceDetails on Magento2_ProductPrice {
    regularPrice {
      value
      currency
    }
    discount {
      amountOff
      percentOff
    }
    fixedProductTaxes {
      label
      amount {
        value
        currency
      }
    }
    finalPrice {
      value
      currency
    }
  }
`;

export const TEMP_PRODUCTS_QUERY = gql`
  ${PRICE_DETAILS_FRAGMENT}

  query TempProductsQuery($currentPage: Int) {
    magento2 {
      products(search: "", pageSize: 20, currentPage: $currentPage) {
        pageInfo {
          pageSize
          totalPages
          currentPage
        }
        items {
          uid
          name
          sku
          stockStatus
          priceRange {
            minimumPrice {
              ...PriceDetails
            }
            maximumPrice {
              ...PriceDetails
            }
          }
          __typename
        }
      }
    }
  }
`;

export const TEMP_PRODUCT_BUNDLE_DETAILS_QUERY = gql`
  query TempProductBundleDetailsQuery($sku: String!) {
    magento2 {
      products(filter: { sku: { eq: $sku } }) {
        items {
          uid
          ... on Magento2_BundleProduct {
            items {
              uid
              sku
              title
              type
              options {
                uid
                quantity
                canChangeQuantity
                isDefault
                label
                price
              }
            }
          }
          __typename
        }
      }
    }
  }
`;
